import React from 'react';
import { Link } from 'react-router-dom';
import AppIcons from '../../assets/images/icons/index';
import AppLayout from '../../layouts/app/AppLayout';
import VerificationForm from '../../forms/verificationForm';
import './auth.scss';


const RegisterPage = () => {
    // custom register functions here
    const pageName = 'Verification';
    return (
        <AppLayout
            
            pageName={pageName}
            bodyClassName='Verification-wrapper auth-layout'
        >
            <div className='auth-page-layout f-wrp'>
                <div className='main-container-wrp'>
                    <div className='flex-box'>
                        <div className='form-sec-wrp'>
                            <Link to={'/'} className='auth-logo'><img src={AppIcons.BlueLogo} alt='WDP' /></Link>
                            <div className='auth-form'>
                                <VerificationForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default RegisterPage;